module.exports = __webpack_public_path__ + "img/gratification-alert.04d87887.svg";